import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "../../validation-types/SchemaDefinition";

export const setUserPayrollRunSettings = (axios: IAxiosInstance) => {
  return async (
    requestBody: ISchema["#/definitions/ISetUserPayrollRunSettingsRequest"]
  ) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/ISetUserPayrollRunSettingsResponse"]
    >(`/api/setUserPayrollRunSettings`, requestBody);
    const resData = response.data;

    if (resData.success) {
      return resData;
    }

    throw new Error("Something went wrong");
  };
};
